<div class="smart-cart-form__tab-container" [hidden]="!!editingBlock && !!editingFormGroup">
  <pdq-tabs-group variant="underline" (onChange)="onTabChange($event)" [leftMargin]="'none'">
    @for (tab of tabs; track tab.value) {
      <pdq-tab [label]="tab.label" [value]="tab.value" [active]="tab.value === activeTab"></pdq-tab>
    }
  </pdq-tabs-group>

  <div class="smart-cart-form__content">
    <smart-cart-form-order-management
      [style.display]="activeTab === SmartCartFormTab.ORDER_MANAGEMENT ? null : 'none'"
      [formGroup]="formGroup"
      [loadedWidgets]="loadedWidgets"
      [globalSettingsFormGroup]="globalSettingsFormGroup"
      (editBlock)="onEditBlock($event)"></smart-cart-form-order-management>
    <smart-cart-form-global-settings
      [style.display]="activeTab === SmartCartFormTab.GLOBAL_SETTINGS ? null : 'none'"
      [formGroup]="globalSettingsFormGroup"></smart-cart-form-global-settings>
  </div>
</div>

@if (editingBlock && editingFormGroup) {
  <div class="smart-cart-form__editor" [trackSection]="editingBlock.type" [trackSectionChanged]="isEditingBlockChanged">
    @switch (editingBlock.type) {
      @case (SmartCartBlockType.TOP_BAR) {
        <smart-cart-form-top-bar-editor
          [formGroup]="$any(editingFormGroup)"
          [usageToken]="editingBlock.usageToken"
          [smartCartId]="smartCartId"></smart-cart-form-top-bar-editor>
      }
      @case (SmartCartBlockType.ANNOUNCEMENT_BAR) {
        <smart-cart-form-announcement-bar-editor
          [formGroup]="$any(editingFormGroup)"
          [usageToken]="editingBlock.usageToken"></smart-cart-form-announcement-bar-editor>
      }
      @case (SmartCartBlockType.GOALS_PROGRESS_BAR) {
        <smart-cart-form-goals-progress-bar-editor
          [formGroup]="$any(editingFormGroup)"
          [usageToken]="editingBlock.usageToken"
          [smartCartId]="smartCartId"
          [globalSettingsFormGroup]="globalSettingsFormGroup"></smart-cart-form-goals-progress-bar-editor>
      }
      @case (SmartCartBlockType.CART_SUBTOTAL) {
        <smart-cart-form-cart-subtotal-editor
          [formGroup]="$any(editingFormGroup)"
          [usageToken]="editingBlock.usageToken"></smart-cart-form-cart-subtotal-editor>
      }
      @case (SmartCartBlockType.CHECKOUT_AREA) {
        <smart-cart-form-checkout-area-editor
          [formGroup]="$any(editingFormGroup)"
          [usageToken]="editingBlock.usageToken"
          [globalSettingsFormGroup]="globalSettingsFormGroup"></smart-cart-form-checkout-area-editor>
      }
      @case (SmartCartBlockType.DISCOUNT_CODES) {
        <smart-cart-form-discount-codes-editor
          [formGroup]="$any(editingFormGroup)"
          [usageToken]="editingBlock.usageToken"
          [globalSettingsFormGroup]="globalSettingsFormGroup"></smart-cart-form-discount-codes-editor>
      }
      @case (SmartCartBlockType.CART_ITEMS) {
        <smart-cart-form-cart-items-editor
          [formGroup]="$any(editingFormGroup)"
          [usageToken]="editingBlock.usageToken"
          [globalSettingsFormGroup]="globalSettingsFormGroup"></smart-cart-form-cart-items-editor>
      }
      @case (SmartCartBlockType.DIGITAL_UPSELL) {
        <smart-cart-form-digital-upsell-editor
          [formGroup]="$any(editingFormGroup)"
          [usageToken]="editingBlock.usageToken"
          [smartCartId]="smartCartId"></smart-cart-form-digital-upsell-editor>
      }
      @case (SmartCartBlockType.UPSELL_ITEMS) {
        <smart-cart-form-upsell-items-editor
          [formGroup]="$any(editingFormGroup)"
          [usageToken]="editingBlock.usageToken"
          [smartCartId]="smartCartId"
          [globalSettingsFormGroup]="globalSettingsFormGroup"></smart-cart-form-upsell-items-editor>
      }
      @case (SmartCartBlockType.ORDER_PROTECTION) {
        <smart-cart-form-order-protection-editor
          [formGroup]="$any(editingFormGroup)"
          [usageToken]="editingBlock.usageToken"></smart-cart-form-order-protection-editor>
      }
    }
  </div>
}
